module.exports = __webpack_public_path__ + "static/media/configure-inventory.32116d75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/configure-inventory.svg
// module id = ./src/statsradio/assets/img/configure-inventory.svg
// module chunks = 18